var AbstractDataModel = require("./AbstractDataModel")

/**
 * @constructor CustomScreenFieldModel
 * @param {object} field field data from the API
 * @param {CustomScreenModel} customScreen Custom Screen (that the field is attached to)
 */
function CustomScreenFieldModel(field, customScreen) {
  var self = this;

  AbstractDataModel.apply(self, arguments);

  self.parent = customScreen;
  self.id = field.id;
  self.type = field.type.toLowerCase();
  self.name = field.name.replace(/[^a-zA-Z0-9]/g, '_');
  self.fieldLength = (field.length) ? field.length : null;

  // self.hidden = ko.observable(false);
  self.includeConsumerName = (customScreen && customScreen.includeConsumerName) ? customScreen.includeConsumerName : false;
  self.enableWhitelist = (field.enableWhitelist && field.enableWhitelist === true);
  self.mustMatchExisting = (field.mustMatchExisting && field.mustMatchExisting === true);
  self.rawOptions = [];
  self.required = (field.required && field.required === true);
  // self.prefix = ko.observable(self.parent.messageBroker.get('customKioskField.' + obj.name + '.prefix'));
  self.inputMask = (self.type === 'number' ? (field.inputMask || '0#') : null) || field.inputMask;
  self.queueIds = field.queueIds;

  if (field.customKioskFieldOptions && field.customKioskFieldOptions.customKioskFieldOption) {
    self.rawOptions = field.customKioskFieldOptions.customKioskFieldOption;
  }

  // Buttons and radio buttons are only used for Kiosk
  // Convert to Select elements for CEC
  if (['button', 'radiobutton', 'autocomplete'].indexOf(field.type.toLowerCase()) > -1) {
    self.type = this.TYPES.SELECT;
  }

  self.hasQueueFilteringOptions = function () {
    return self.rawOptions.filter(function (opt) {
      return opt.queueIds && opt.queueIds !== '';
    }).length > 0
  };

  // TODO: Remove AddConsumerViewModel dependency.
  self.isValid = function () {
    var val = vm.addConsumerVM.customScreenFieldObservable(self.name)().trim();

    if (self.required || self.optionsHaveQueueIds()) {
      // If the value is falsey, then set the observable to null
      if (!val) {
        vm.addConsumerVM.customScreenFieldObservable(self.name, null);
        return false;
      }
      // If the field has an input mask, but the value doesn't match
      else if (self.inputMask && val.toString().length != self.inputMask.length) {
        valid = false;
      }
    }

    return true;
  };

  self.optionsHaveQueueIds = function () {
    return self.rawOptions.length > 0 && self.rawOptions.filter(function (opt) {
      return opt.queueIds && opt.queueIds != '';
    }).length > 0
  } 

  /**
   * Provides a method to convert a label to locale
   *
   * @method label
   * @return {String}
   */
  self.label = ko.deferredComputed(function () {
    var langLabel = self.parent.messageBroker.get('customField.' + field.name + '.label');

    if (langLabel !== '') {
      return langLabel;
    }

    return field.label;
  });


  /**
   * Provides a method to convert option values to locale
   *
   * @method options
   * @return {Array}
   */
  self.options = ko.deferredComputed(function () {
    var arr = [];

    self.rawOptions.forEach(function (option, idx) {
      val = self.parent.messageBroker.get(option.value);

      if (val === '') {
        val = self.rawOptions[idx].value;
      }

      arr.push(val);
    });

    return arr;
  });


  /**
   * Looks up a Message table entry for the padding char
   *
   * @method paddingChar
   * @return {String | Null}
   */
  self.paddingChar = ko.deferredComputed(function () {
    return self.parent.messageBroker.get('customField.' + self.name + '.paddingChar') || null;
  });


  // Softly create a matching observable on the view model
  if (window.vm !== undefined) {
    vm.addConsumerVM.customScreenFieldObservable(self.name)();
  }


  self.reset = function () {
    vm.addConsumerVM.customScreenFieldObservable(self.name, null);
  };

  this.isInputElement = ko.pureComputed(this._isInputElement, this)
  this.isSelectElement = ko.pureComputed(this._isSelectElement, this)
  this.isCheckbox = ko.pureComputed(this._isCheckbox, this)
  this.isText = ko.pureComputed(this._isText, this)
  this.isNumber = ko.pureComputed(this._isNumber, this)
  this.isTextual = ko.pureComputed(this._isTextual, this)

  return self;
};

CustomScreenFieldModel.prototype = Object.create(AbstractDataModel.prototype);
CustomScreenFieldModel.prototype.constructor = CustomScreenFieldModel;

CustomScreenFieldModel.prototype.TYPES = {
  TEXT: "text",
  NUMBER: "number",
  CHECKBOX: "checkbox",
  SELECT: "select"
};

CustomScreenFieldModel.prototype.DEFAULT_LENGTH = 999

CustomScreenFieldModel.prototype._isInputElement = function() {
  return [this.TYPES.TEXT, this.TYPES.NUMBER, this.TYPES.CHECKBOX].indexOf(this.type) != -1
}

CustomScreenFieldModel.prototype._isSelectElement = function() {
  return this.TYPES.SELECT == this.type
}

CustomScreenFieldModel.prototype._isCheckbox = function() {
  return this.TYPES.CHECKBOX == this.type
}

CustomScreenFieldModel.prototype._isText = function() {
  return this.TYPES.TEXT == this.type
}

CustomScreenFieldModel.prototype._isNumber = function() {
  return this.TYPES.NUMBER == this.type
}

CustomScreenFieldModel.prototype._isTextual = function() {
  return this.isText() || this.isNumber()
}

CustomScreenFieldModel.prototype.validate = function (value) {
  if (!this.isRequired() && this.isEmptyValue(value)) {
    // If optional fields are empty, we won't required them to validate
    return { valid: true, reason: this.VALID_OPTIONAL }
  }

  if (this.isRequired && this.isEmptyValue(value)) {
    return { valid: false, reason: this.INVALID_REQUIRED }
  }

  if (this.type == this.TYPES.NUMBER && (!this.isEmptyValue(value) && !this.isNumberValue(value))) {
    return { valid: false, reason: this.INVALID_NUMBER }
  }

  if (this.optionsHaveQueueIds() && this.isEmptyValue(value)) {
    // If the options have Queue IDs, then a selection is required in order to be placed into a Queue.
    return { valid: false, reason: this.INVALID_REQUIRED } 
  }

  if (this.exceedsLength(value)) {
    return { valid: false, reason: this.INVALID_LENGTH }
  }

  return { valid: true, reason: null }
}

CustomScreenFieldModel.prototype.isEmptyValue = function (value) {
  return (value == false || value == undefined || value == null || value == "")
}

CustomScreenFieldModel.prototype.isNumberValue = function (value) {
  if (!(typeof value == "string" && value != "")) {
    return false
  }

  var pattern = new RegExp("^\\d+$")
  return pattern.test(value) 
}

CustomScreenFieldModel.prototype.isRequired = function () {
  return this.required || this.optionsHaveQueueIds()
}

CustomScreenFieldModel.prototype.exceedsLength = function (value) {
  if (this.fieldLength === null)  {
    return false
  }

  var exceeds = (value.length > this.fieldLength)

  return exceeds
}

CustomScreenFieldModel.prototype.INVALID_REQUIRED = "required"
CustomScreenFieldModel.prototype.INVALID_NUMBER = "number"
CustomScreenFieldModel.prototype.INVALID_PATTERN = "pattern"
CustomScreenFieldModel.prototype.INVALID_LENGTH = "length"
CustomScreenFieldModel.prototype.VALID_OPTIONAL = "optional"

module.exports = CustomScreenFieldModel
